import { createMuiTheme } from "@material-ui/core";

export default createMuiTheme({
  props: {},

  overrides: {
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#112345",
          fontWeight: "bold",
          fontSize: "15px"
        },
      },

      focused: {},
    },
    MuiAppBar: {
      root: {
        paddingLeft: "30px",
        paddingRight: "30px",
      },
    },
    MuiToolbar: {
      root: {
        textTransform: "capitalize",
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: "#112345",
        "&$checked": {
          color: "#112345",
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: "14px",
      },
    },
    MuiInputBase: {
      root: {
        fontSize: "14px",
      },
    },
    MuiIcon: {
      root: {
        fontSize: "20px",
      },
    },
    MuiFab: {
      root: {
        boxShadow: "none",
        border: "1px solid #bbbbbb",
      },
    },
     MuiInputLabel: {
      root: {
        fontSize: "14px",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
     }
  },
  palette: {
    // background: {
    //   default: '#FFFFFF',
    //   paper: '#EFEFEF'
    // },
    primary: {
      light: "#207b7c",
      main: "#112345",
      dark: "#112345",
      contrastText: "#FFFFFF",
    },
  },

  typography: {
    fontFamily: "Montserrat, sans-serif;",
    h1: {
      fontFamily: "Montserrat, sans-serif;",
      fontSize: "20px",
    },
    h2: {},
    h3: {},
    h4: {},
    h5: {},
    h6: {},
    subtitle1: {
      // fontSize: '24px',
    },
    subtitle2: {
      // fontSize: '24px',
    },
    body1: {
      fontSize: "20px",
    },
    body2: {
      fontSize: "16px",
    },
  },
});
